<div class="widgets-empty">

  @if (isStoreView) {

    <app-empty-button size="large"></app-empty-button>
    <app-empty-button size="large"></app-empty-button>

  } @else {

    <app-empty-widget
      [title]="'WIDGETS.ADD_FAVORITES' | translate"
      (click)="setFavoritesWidgets.emit()"
    ></app-empty-widget>

  }

</div>
